import React from 'react'

export default function JobProfilemain() {
  return (
    <div>
      <JobProfilemain/>
    </div>
  )
}
